import Image from "next/image";
import { themeClasses, type Theme } from "@cw/design-tokens/theme";
import { ContainedSection, SectionHeader } from "../primitives/Section";
export function LogoWall({ heading, items, theme = "mist", grayscale = true }: { heading?: string; items: { name: string; src: string; width: number; height: number }[]; theme?: Theme; grayscale?: boolean }) {
  const t = themeClasses(theme);
  return (
    <ContainedSection theme={theme} compact>
      <SectionHeader heading={heading} theme={theme} align="center" />
      <ul className="grid grid-cols-2 items-center gap-8 sm:grid-cols-3 lg:grid-cols-6">
        {items.map((l) => (
          <li key={l.name} className={`flex items-center justify-center ${grayscale ? "opacity-70 grayscale transition hover:opacity-100 hover:grayscale-0" : ""}`}>
            <Image src={l.src} alt={l.name} width={l.width} height={l.height} className={`h-10 w-auto ${t.isDark ? "brightness-0 invert" : ""}`} />
          </li>
        ))}
      </ul>
    </ContainedSection>
  );
}
